// Nuevo ServicioDetalle.jsx con toda la información expandida y mejorada

import React from "react";
import { useParams } from "react-router-dom";
import {
  Container,
  Card,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
} from "react-bootstrap";
import postImg from "../assets/images/tratpost.jpeg";
import limpiezaImg from "../assets/images/limpfac.jpeg";
import moldeoImg from "../assets/images/postquirurgicos.jpg";
import reduccionImg from "../assets/images/redcmed.jpeg";
import celulitisImg from "../assets/images/elimcelu.jpeg";
import rejuveneceImg from "../assets/images/rejuv.jpeg";
import manchasImg from "../assets/images/elimanch.jpeg";
import masajesImg from "../assets/images/masrela.jpeg";

const contenidoServicios = {
  moldeo: {
    titulo: "Moldeo Corporal",
    imagen: moldeoImg,
    puntos: [
      "Masaje Reductor/Moldeador personalizado",
      "Drenaje Linfático Manual",
      "Cavitación y Vacumterapia",
      "Criolipólisis y Electroestimulación",
    ],
    descripcion:
      "El moldeado corporal en Sanus Esthetic combina técnicas manuales y tecnología avanzada para mejorar el contorno corporal. Diseñamos un protocolo personalizado según tus necesidades, trabajando abdomen, piernas, glúteos y más.",
  },
  reduccion: {
    titulo: "Reducción de Medidas",
    imagen: reduccionImg,
    puntos: [
      "Cavitación para romper grasa localizada",
      "Drenaje linfático o presoterapia",
      "Vacumterapia para mejorar la circulación",
      "Masaje reductor intensivo",
    ],
    descripcion:
      "Buscamos esculpir tu silueta con técnicas combinadas que eliminan grasa localizada, mejoran la circulación y tonifican tu piel. Te asesoramos con hábitos saludables para resultados duraderos.",
  },
  celulitis: {
    titulo: "Eliminación de Celulitis",
    imagen: celulitisImg,
    puntos: [
      "Radiofrecuencia para firmeza",
      "Presoterapia o drenaje linfático",
      "Ondas de choque acústicas",
      "Mesoterapia virtual y masajes anticelulíticos",
    ],
    descripcion:
      "Reducimos significativamente la celulitis con un enfoque integral. Evaluamos tu tipo de celulitis y combinamos técnicas específicas para lograr una piel más lisa, tonificada y libre de hoyuelos.",
  },
  postquirurgicos: {
    titulo: "Tratamientos Post-Quirúrgicos",
    imagen: postImg,
    puntos: [
      "Drenaje linfático manual y aparatología",
      "Reducción de fibrosis y adherencias",
      "Ultrasonido para cicatrización",
      "Seguimiento profesional y personalizado",
    ],
    descripcion:
      "Nuestros tratamientos postquirúrgicos están diseñados para optimizar tu recuperación, reducir inflamación y fibrosis, y mejorar los resultados estéticos.",
  },
  limpieza: {
    titulo: "Limpieza Facial Profunda",
    imagen: limpiezaImg,
    puntos: [
      "Diagnóstico profesional y doble limpieza",
      "Exfoliación y extracción de impurezas",
      "Alta frecuencia antibacterial",
      "Mascarilla personalizada y protección solar",
    ],
    descripcion:
      "Purifica y revitaliza tu piel con nuestra limpieza profunda profesional. Ideal para eliminar toxinas, puntos negros y mejorar la textura de tu piel.",
  },
  rejuvenece: {
    titulo: "Rejuvenecimiento Facial",
    imagen: rejuveneceImg,
    puntos: [
      "Peelings químicos y microdermoabrasión",
      "Radiofrecuencia y LED terapia",
      "Sueros y mascarillas nutritivas",
      "Masaje facial drenante y reafirmante",
    ],
    descripcion:
      "Atenúa arrugas, manchas y flacidez con un tratamiento facial integral y personalizado. Recupera luminosidad y frescura en tu rostro.",
  },
  manchas: {
    titulo: "Eliminación de Manchas",
    imagen: manchasImg,
    puntos: [
      "Diagnóstico profesional del tipo de mancha",
      "Peelings despigmentantes y microdermoabrasión",
      "Terapia tópica con activos como Vitamina C, ácido kójico y retinoides",
      "Plan de mantenimiento personalizado",
    ],
    descripcion:
      "Elimina y previene manchas solares, melasma o marcas de acné. Nuestro tratamiento está basado en diagnóstico, tecnología despigmentante y educación en protección solar.",
  },
  masajes: {
    titulo: "Masajes Relajantes",
    imagen: masajesImg,
    puntos: [
      "Consulta personalizada y aromaterapia",
      "Masajes con técnicas relajantes expertas",
      "Ambiente armónico y musicalización suave",
      "Beneficios antiestrés y descanso profundo",
    ],
    descripcion:
      "Disfruta de una experiencia de relajación total. Nuestros masajes reducen tensión, promueven el bienestar mental y mejoran tu calidad de sueño.",
  },
};

export default function ServicioDetalle() {
  const { nombre } = useParams();
  const servicio = contenidoServicios[nombre];

  if (!servicio) {
    return (
      <Container className="py-5 text-center fade-in">
        <h3 className="text-danger">Servicio no encontrado</h3>
      </Container>
    );
  }

  return (
    <Container
      className="py-5 fade-in"
      style={{ background: "#f0fcfc", borderRadius: 12 }}
    >
      <Row className="align-items-center">
        <Col md={6} className="text-center">
          <Card.Img
            variant="top"
            src={servicio.imagen}
            alt={servicio.titulo}
            style={{
              width: "100%",
              height: "auto",
              borderRadius: 10,
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              objectFit: "cover",
            }}
          />
        </Col>
        <Col md={6}>
          <h2 style={{ color: "#056d7a" }}>{servicio.titulo}</h2>
          <p className="text-muted fs-5">{servicio.descripcion}</p>
          <ListGroup variant="flush">
            {servicio.puntos.map((pt, i) => (
              <ListGroupItem key={i} style={{ border: 0, paddingLeft: 0 }}>
                • {pt}
              </ListGroupItem>
            ))}
          </ListGroup>
        </Col>
      </Row>
    </Container>
  );
}
